export default {
    namespaced: true,
    state: {
        aard: null
    },
    getters: {
        aard: (state) => {
            return state.aard;
        },
        findAard: (state) => (aardId) => {
            for(let index in state.aard) {
                if(state.aard.hasOwnProperty(index)) {
                    if(state.aard[index].id === aardId) {
                        return state.aard[index];
                    }
                }
            }
            return null;
        }
    },
    actions: {

    },
    mutations: {
        aard (state, aard) {
            state.aard = aard;
        }
    }
}